/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum GeoFilter {
  DomesticCanada = "DomesticCanada",
  DomesticUsa = "DomesticUSA",
  CrossBorder = "CrossBorder",
  CrossBorderSouth = "CrossBorderSouth",
  CrossBorderNorth = "CrossBorderNorth",
}

export function instanceOfGeoFilter(value: any): boolean {
  for (const key in GeoFilter) {
    if (Object.prototype.hasOwnProperty.call(GeoFilter, key)) {
      if (GeoFilter[key as keyof typeof GeoFilter] === value) {
        return true;
      }
    }
  }
  return false;
}

export function GeoFilterFromJSON(json: any): GeoFilter {
  return GeoFilterFromJSONTyped(json, false);
}

export function GeoFilterFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GeoFilter {
  return json as GeoFilter;
}

export function GeoFilterToJSON(value?: GeoFilter | null): any {
  return value as any;
}

export function GeoFilterToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): GeoFilter {
  return value as GeoFilter;
}
